import $ from "jquery"
import "bootstrap/js/dist/collapse"
import { isMobileDevice } from "../../js/utils/helper"
import SimpleBar from "simplebar";

class Header {
	constructor() {
		// eslint-disable-next-line no-console
		console.log("Header::initialize()")

		this._$menuContainer = $(".bb-header__menu-container")
		this._$burger = $(".bb-hamburger")
		this._$channelSwitch = $(".bb-header__channel-container--mobile")
		this.isMobile = this._$burger.is(":visible")
		$(document.body).on("click", ".bb-hamburger", this._onBurgerClick.bind(this))

		if (isMobileDevice()) {
			// close open navigation when clicking outside in desktop mode
			$(document.body).on("click", ".full-height-container", () => {
				if (this._$burger.is(":hidden")) {
					$(".bb-header__sub-navi.show").collapse("hide")
				}
			})

			if (this._$channelSwitch.find(".bb-header__channel-items").length) {
				new SimpleBar(this._$channelSwitch.find(".bb-header__channel-items").get(0), {autoHide: false})
			}
		} else {
			$(document.body).on("mouseenter", ".bb-header__main-link-container", this._onItemHover.bind(this))
			$(document.body).on("mouseleave", ".bb-header__main-link-container", this._onItemLeave.bind(this))
		}

		// handle click on mobile navigation black background on right side
		$(document.body).on("click", ".bb-header__menu-container", (e) => {
			if (this._$burger.is(":visible") && $(e.target).hasClass("bb-header__menu-container")) {
				this._$burger.trigger("click")
			}
		})

		// handle click to open mobile subnavigation
		$(document.body).on("click", ".bb-header__main-link--has-children", (e) => {
			if (this._$burger.is(":hidden")) {
				// open link href in desktop mode
				window.location.href = $(e.target).closest(".bb-header__main-link").attr("href")
			} else {
				const $current = $(e.target).closest(".bb-header__main-link")
				const $linkLevel1 = $(".bb-header__yellow-stripe .link-back-level-1 > a")
				$linkLevel1.text($current.text())
				$linkLevel1.attr("data-bs-target", $current.data("bs-target"))
				this._$menuContainer.addClass("show-sub-level-1")

				// reset scrollpos of container
				$current.siblings(".bb-header__sub-navi")[0].scrollTop = 0
			}
		})

		// handle click to open mobile subnavigation second level
		$(document.body).on("click", ".bb-header__sub-navi-link--has-children", (e) => {
			if (this._$burger.is(":visible")) {
				const $current = $(e.target).closest(".bb-header__sub-navi-link")
				const $linkLevel2 = $(".bb-header__yellow-stripe .link-back-level-2 > a")
				$linkLevel2.text($current.text())
				$linkLevel2.attr("data-bs-target", $current.data("bs-target"))
				this._$menuContainer.addClass("show-sub-level-2")

				// reset scrollpos of container
				$current.siblings(".bb-header__sub-navi")[0].scrollTop = 0
			}
		})

		// handle click on mobil subnavigation back button
		$(document.body).on("click", ".bb-header__yellow-stripe a", (e) => {
			$(e.target).closest("a").removeAttr("data-bs-target")

			if (this._$menuContainer.hasClass("show-sub-level-2")) {
				this._$menuContainer.removeClass("show-sub-level-2")
			} else {
				this._$menuContainer.removeClass("show-sub-level-1")
			}
		})

		// handle click on mobil channels
		$(document.body).on("click", ".bb-header__channel-current", this._onOpenChannelSwitch.bind(this))
		$(document.body).on("click", (event) => {
			if (
				this._$channelSwitch.length > 0 &&
				!this._$channelSwitch.get(0).contains(event.target) &&
				this._$channelSwitch.hasClass("open")
			) {
				this._$channelSwitch.find(".bb-header__channel-current").trigger("click")
			}
		})

		// reset scrollpos of container for desktop mode
		$(document.body).on("hidden.bs.collapse", ".bb-header__sub-navi", (e) => {
			if (this._$burger.is(":hidden")) {
				const $subNav = $(e.target).closest(".bb-header__sub-navi")
				$subNav.addClass("show")
				$subNav[0].scrollTop = 0
				$subNav.removeClass("show")
			}
		})

		$(document.body).on("mouseenter", ".bb-header__sub-navi-link.teaser", this._onTeaserHover)
		$(document.body).on("mouseleave", ".bb-header__sub-navi-link.teaser", this._onTeaserLeave)

		$(window).on("resize", () => {
			if (this._$burger.is(":visible") !== this.isMobile) {
				if (this.isMobile) {
					$(document.body).removeClass("mobile-navigation-open")
					this._removeSubLevelClasses()
				}
				this.isMobile = !this.isMobile
			}

			if (this._$channelSwitch.length > 0 && this._$channelSwitch.hasClass("open")) {
				this._$channelSwitch.find(".bb-header__channel-current").trigger("click")
			}
		})

		$(".bb-header").on("click", `a.bb-header__sub-navi-link[href^="${window.location.origin}${window.location.pathname}${window.location.search}#"]`, () => {
			if (isMobileDevice()) {
				 if($("body").hasClass("mobile-navigation-open")) $(".bb-hamburger").trigger("click")
			} else {
				this._onItemLeave({target: $(".bb-header").find(".bb-header__main-link:not(.collapsed)")})
			}
		})
	}

	/**
	 * handle click on header navigation burger
	 * @private
	 */
	_onBurgerClick(e) {
		e.preventDefault()

		if ($(document.body).hasClass("mobile-navigation-open")) {
			$(document.body).removeClass("mobile-navigation-open")

			this._removeSubLevelTimeout = window.setTimeout(() => {
				this._removeSubLevelClasses()
			}, 400)
		} else {
			if (this._removeSubLevelTimeout) {
				this.raf = window.clearTimeout(this._removeSubLevelTimeout)
				this._removeSubLevelClasses()
			}

			// reset scroll posiiton inside navigation
			$(".bb-header__menu-container").scrollTop(0)

			$(document.body).addClass("mobile-navigation-open")
		}
	}

	/**
	 * handle header link item hover
	 * @private
	 */
	_onItemHover(e) {
		const $collapsingItem = $(e.target).closest(".bb-header__main-link-container").find("> .bb-header__sub-navi")

		if (this._$burger.is(":visible") || $collapsingItem.length === 0) {
			return false
		}

		window.cancelAnimationFrame(this.raf)

		// check if animation is currently running
		if ($collapsingItem.hasClass("collapsing")) {
			$collapsingItem[0].dispatchEvent(new Event("transitionend"))
			this.raf = window.requestAnimationFrame(() => {
				$collapsingItem.collapse("show")
			})
		} else {
			$collapsingItem.collapse("show")
		}
	}

	/**
	 * handle breadcrumb item hover
	 * @private
	 */
	_onItemLeave(e) {
		const $collapsingItem = $(e.target).closest(".bb-header__main-link-container").find("> .bb-header__sub-navi")

		if (this._$burger.is(":visible") || $collapsingItem.length === 0) {
			return false
		}

		window.cancelAnimationFrame(this.raf)

		// check if animation is currently running
		if ($collapsingItem.hasClass("collapsing")) {
			$collapsingItem[0].dispatchEvent(new Event("transitionend"))
			window.requestAnimationFrame(() => {
				$collapsingItem.collapse("hide")
			})
		} else {
			$collapsingItem.collapse("hide")
		}
	}

	/**
	 * remove classes for open sublevel navigations
	 * @private
	 */
	_removeSubLevelClasses() {
		this._removeSubLevelTimeout = null

		if (this._$menuContainer.hasClass("show-sub-level-1")) {
			this._$menuContainer.find(".bb-header__yellow-stripe a").each((index, elem) => {
				if ($(elem).data("bs-target")) {
					$(elem).removeAttr("data-bs-target")

					$($(elem).data("bs-target")).collapse("hide")
				}
			})

			this._$menuContainer.removeClass("show-sub-level-1 show-sub-level-2")
		}
	}

	/**
	 * handle header teaser hover
	 * @private
	 */
	_onTeaserHover(e) {
		const $image = $(e.currentTarget).find(".bb-image")

		if ($image.hasClass("has-hover-animation")) {
			$image.addClass("hover")
		}
	}

	/**
	 * handle header teaser hover leave
	 * @private
	 */
	_onTeaserLeave(e) {
		const $image = $(e.currentTarget).find(".bb-image")

		if ($image.hasClass("has-hover-animation")) {
			$image.removeClass("hover")
		}
	}

	/**
	 * handle channel switch click
	 * @private
	 */
	_onOpenChannelSwitch(event) {
		const $target = $(event.target)
		const $channelSwitch = $target.closest(".bb-header__channel-container--mobile")

		if ($channelSwitch.hasClass("open")) {
			$channelSwitch.removeClass("open")
			$channelSwitch.find(".bb-header__channel-items").slideUp()
		} else {
			$channelSwitch.addClass("open")
			$channelSwitch.find(".bb-header__channel-items").slideDown()
		}
	}
}

export default Header
